<template>
    <basic-card>
        <template #header>
            {{ $t("cashflow.reportDefinitions") }}
        </template>
        <data-table
          :data="definitions"
          :configuration="definitionTableConfig"
          @add="addDefinition"
          @delete="deleteDefinition"
          @duplicate="duplicateDefinition"
          @focusedChanged="focusedChanged"
          component-id="cashflow-definitions-list"
        >
            <var-report-definition-card
              v-if="focusedDefinition != null"
              :definition="focusedDefinition"
              @save="handleSave"
            />
        </data-table>
    </basic-card>
</template>

<script>
import BasicCard from "../components/layout/BasicCard";
import { mapGetters } from "vuex";
import VarReportDefinitionCard from "../cards/VarReportDefinitionCard";
import DataTable from "../components/table/DataTable";
import Axios from "axios";

export default {
    name: "VarCalculationDefinitionsView",
    components: {
        DataTable,
        VarReportDefinitionCard,
        BasicCard
    },
    data: function () {
        return {
            definitions: [],
            focusedDefinition: null,
            definitionTableConfig: {
                allowEdit: true,
                enableAdd: true,
                columns: [
                    {
                        caption: this.$t("name"),
                        datum: d => d.name
                    },


                    {
                        caption: this.$t("reporting.currency"),
                        datum: d => d.currency
                    },


                    {
                        caption: this.$t("reporting.volatility"),
                        datum: d => d.volatilityCode
                    },

                    {
                        caption: this.$t("reporting.startDateExpression"),
                        datum: d => {
                            let formatted = this.$formats.formatDate(d.cashflowDateFrom);
                            if (formatted === 'Invalid date') return d.cashflowDateFrom
                            else return formatted;
                        }
                    },
                    {
                        caption: this.$t("reporting.endDateExpression"),
                        datum: d => {
                            let formatted = this.$formats.formatDate(d.cashflowDateTo);
                            if (formatted === 'Invalid date') return d.cashflowDateTo
                            else return formatted;
                        }
                    },
                ],

            }
        }
    },
    computed: {
        ...mapGetters({
            volatilities: "volatilities/volatilities",
            cashEventQueries: "cashEventQueries/cashEventQueries",
        }),
    },

    async mounted() {
        await this.$store.dispatch(`accountQueries/refreshAccountQueries`)
        await this.$store.dispatch(`cashEventQueries/refreshCashEventQueries`)
        await this.refreshData();
    },

    methods: {
        focusedChanged(focused) {
            this.$set(this, 'focusedDefinition', focused)
        },
        addDefinition() {
            this.focusedDefinition = {
              cashEventsQueries: [],
              cashEventRemoveQueries: [],
            };
        },
        deleteDefinition(definition) {
            if (this.focusedDefinition != null && this.focusedDefinition.id === definition.id) {
                this.focusedDefinition = null;
            }
            this.$store.dispatch("cashflowReportDefinitions/deleteCashflowReportDefinition", definition)
              .then(this.refreshData)
        },
        duplicateDefinition(definition) {
            this.focusedDefinition = {...definition, id: undefined, name: "Copy of " + definition.name}
        },
        async handleSave(definition, keepFocused, callback) {
            let response = null;
            if (definition.id) {
                response = await Axios.put(`/value-at-risk/api/v1/definitions/${definition.id}`, definition);
            } else {
                response = await Axios.post(`/value-at-risk/api/v1/definitions`, definition);
            }

            if (!keepFocused) {
                this.focusedDefinition = null;
                await this.refreshData();

                this.$notify({
                    group: 'application',
                    title: this.$t('reporting.saveSuccess'),
                    text: this.$t('reporting.saveSuccess'),
                    type: "ok"
                })

            }
            if (callback) {
                await this.refreshData();
                await callback();
            }
        },


        async refreshData() {
            await this.$store.dispatch('volatilities/refreshVolatilities')

            const response = await Axios.get(`/value-at-risk/api/v1/definitions`);

            for (const value of response.data) {

                const volatilityCode  = this.volatilities.find(vol => vol.id === value.volatilityId)?.name ?? 'N/A';

                value.volatilityCode = `${volatilityCode } (${value.gridPoint})`
            }

            this.definitions = response.data;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../styles/global";


</style>
